import React, { useMemo } from 'react'

import { pluralizeToString } from 'lib/pluralize'
import FormatCurrency from 'components/Common/FormatCurrency'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import { connect } from 'react-redux'
import { buildSuggestedDatesParamsKey, buildSuggestedDatesString } from 'lib/searchUtils'
import { getSuggestedDates } from 'selectors/offerSelectors'

interface MappedStateProps {
  suggestedDates: App.OfferSuggestedDates;
}
export interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  price: number
  duration: number
  filters: App.OfferListFilters
}

function MapViewBedbankPricing(props: Props & MappedStateProps) {
  const {
    offer,
    price,
    duration,
    suggestedDates,
  } = props

  const hasSuggestedCheckInCheckOut = suggestedDates?.checkIn && suggestedDates?.checkOut

  const durationText = useMemo(() => {
    if (!duration) {
      return 'from'
    }
    if (hasSuggestedCheckInCheckOut) {
      return buildSuggestedDatesString(suggestedDates.checkIn, suggestedDates.checkOut)
    }
    return pluralizeToString('night', duration) + ' from'
  }, [duration, hasSuggestedCheckInCheckOut, suggestedDates])

  return <>
    <BodyText variant="small" align="end">
      {durationText}&nbsp;
      <BodyText variant="medium" weight="bold" as="span">
        <FormatCurrency value={suggestedDates?.price ?? price} format="roundedDollar" />
      </BodyText> /{offer.saleUnit}
    </BodyText>
    <Caption variant="medium" align="end" colour="neutral-three">Incl. taxes &#38; fees</Caption>
  </>
}

export default connect<MappedStateProps, undefined, Props, App.State>((appState, ownProps) => {
  const flexibleSearchFilterKey = buildSuggestedDatesParamsKey(ownProps.filters?.flexibleMonths, ownProps.filters?.flexibleNights, ownProps.filters?.rooms)
  return {
    suggestedDates: getSuggestedDates(appState, flexibleSearchFilterKey, ownProps.offer.id),
  }
})(MapViewBedbankPricing)
